import { TemplatePage } from './types';

const lowerThirdPage: TemplatePage = {
  header: {
    color: '#DCD7F5',
    icon: 'images/video-templates/lower_third.jpg',
    title: 'Lower Third Video Templates',
    title_meta: 'Lower Third Video Templates, Free and Editable',
    description_meta:
      'Create promo videos with a lower third. Make your videos stand out in the feed with a collection of lower third video ' +
      'templates.',
    description:
      'Give your videos a TV-like touch and feel. <br>Make promotional videos like a pro with these templates. Customize texts ' +
      'and colors to get a neat lower third on your video.'
  },
  footer: {
    category: 'Lower Third',
    description:
      'Video templates make video production a breeze. All elements of the template are 100% customizable which allows ' +
      'you to easily transform it into your own video content. Replace the sample footage, change fonts, texts, and colors ' +
      'to tailor a video template to your specific promotional needs. Wave.video features a great variety of video templates ' +
      'for different industries, occasions and use cases.'
  },
  content: [
    {
      type: 'templates',
      title: 'Lower Third Videos',
      search: { name: 'lower third' }
    },
    {
      type: 'stocks',
      title: 'lower third',
      search: { name: 'lower third' }
    },
    { type: 'calendar' }
  ]
};

export default lowerThirdPage;
